export default {
  calendar: {
    today: "Aujourd'hui",
    tomorrow: 'Demain',
    asap: 'ASAP',
  },
};
